import { Action, createReducer, on } from '@ngrx/store';
import { AuthorsState, initialAuthorsState } from '../state/authors.state';
import { getTestFormsListSuccess } from '../actions/authors.action';
import { ODataGetListFormModel } from '@evorait/pace-forms';

function getTestFormsListReducer(
    state: Readonly<AuthorsState>,
    props: { formsList: ODataGetListFormModel[] },
): Readonly<AuthorsState> {
    return {
        ...state,
        formsList: props.formsList,
    };
}

const createAuthorsReducer = createReducer(initialAuthorsState, on(getTestFormsListSuccess, getTestFormsListReducer));

export function AuthorsReducer(state: Readonly<AuthorsState>, action: Action): Readonly<AuthorsState> {
    return createAuthorsReducer(state, action);
}
